import { useMemo } from "react";
import { Simulator } from "@/api/simulator/simulator.model";
import { useGetSimulators } from "@/api/simulator/simulator.api";

export function useGetChatSimulators(onSuccess?: (data: Simulator[]) => void) {
  const { data: simulators, isLoading: isLoadingSimulators } = useGetSimulators(
    (data) => {
      const chatSimulators = data.filter(
        ({ channel }) => channel === "autonomous_quackchat"
      );
      onSuccess?.(chatSimulators);
    }
  );

  const chatSimulators = useMemo(() => {
    return simulators?.filter(
      ({ channel }) => channel === "autonomous_quackchat"
    );
  }, [simulators]);

  return { chatSimulators, isLoading: isLoadingSimulators };
}
